export default __webpack_public_path__ + "static/media/Sammir-Dattani_Director_Sanathan-Textiles-1.c7eca54a.jpg";